import { createListenerMiddleware } from '@reduxjs/toolkit';

import { appListeners } from './app';
import { authCredentialsListeners } from './authCredentials';
import { modalGuardListeners } from './modalGuard';

export const listenerMiddleware = createListenerMiddleware();

appListeners(listenerMiddleware);
authCredentialsListeners(listenerMiddleware);
modalGuardListeners(listenerMiddleware);
